import React from "react";
import ReactModal from "react-modal";
import { faHeart, faCrown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Button from "../../../components/basic/Button";
import { PleaseLogIn } from "../../lobby/PleaseLogIn";
import PatreonButton from "./PatreonButton";
import { Z_INDEX } from "../../engine/functions/common";

ReactModal.setAppElement("#root");

export const PatreonModal = ({
  isOpen,
  isLoggedIn,
  closeModal
}) => {
    const tiers = [
        {
          amount: 300,
          name: "Bronze",
          color: "#CD7F32",
          benefits: [
            "Bronze crown badge next to your name",
            "Unlimited saved games",
            "Saved games include full replay",
            "Favorite prebuilt decks and URLs",
            "Idle room timeout increased from 1 hour to 24 hours",
          ]
        },
        {
          amount: 500,
          name: "Silver",
          color: "#C0C0C0",
          benefits: [
            "Silver crown badge next to your name",
            "All Bronze benefits",
            "Custom alt art cards",
            "Custom card backs",
            "Custom backgrounds",
            "Private custom content",
            "Idle room timeout increased to 3 days",
          ]
        },
        {
          amount: 1000,
          name: "Gold",
          color: "#FFD700",
          benefits: [
            "Gold crown badge next to your name",
            "All Silver benefits",
            `Optional "Esteemed Supporter" discord role`,
            "Access to plugin developer discord channels",
            "Idle room timeout increased to 7 days",
          ]
        },
    ];

  // Get patreon data from environment variables. These must match the values the
  // backend uses for the token exchange, otherwise Patreon rejects the redirect URI.
  const patreonClientId = process.env.REACT_APP_PATREON_CLIENT_ID;
  const redirectURI = process.env.REACT_APP_PATREON_REDIRECT_URI;

  return (
    <ReactModal
      closeTimeoutMS={200}
      isOpen={isOpen}
      onRequestClose={closeModal}
      contentLabel="Support on Patreon"
      overlayClassName="fixed inset-0 bg-black-50 overflow-y-scroll"
      className="insert-auto p-5 bg-gray-700 border mx-auto rounded-lg my-12 outline-none"
      style={{
        overlay: {
          zIndex: Z_INDEX.Modal
        },
        content: {
          width: '1100px',
          maxWidth: '95vw',
        }
      }}>
      <h1 className="mb-2">Support on Patreon</h1>
      {isLoggedIn ? (
        <>
          <div className="text-white text-xs mb-4">For questions about the support tiers, join the <a href="https://discord.gg/7BQv5ethUm" target="_blank" rel="noreferrer">Discord</a>.</div>
          <div className="flex flex-col lg:flex-row gap-4">
            {tiers.map((tier, index) => (
                <div key={index} className="flex-1 border rounded-lg p-3 border-gray-500 flex flex-col">
                  <div className="flex items-center gap-2 mb-2">
                    <FontAwesomeIcon icon={faCrown} style={{ color: tier.color, fontSize: "1.2em" }} />
                    <span className="text-white font-bold text-lg">{tier.name}</span>
                  </div>
                  <PatreonButton
                      patreonClientId={patreonClientId}
                      amount={tier.amount}
                      redirectURI={redirectURI}
                  />
                  <ul className="text-white mt-3 list-disc list-inside text-sm flex-1">
                    {tier.benefits.map((benefit, i) => (
                      <li key={i}>
                        {benefit}
                        {benefit === "Favorite prebuilt decks and URLs" && (
                          <FontAwesomeIcon icon={faHeart} style={{color: "#e53e3e", marginLeft: "6px", fontSize: "0.85em"}}/>
                        )}
                      </li>
                    ))}
                  </ul>
                </div>
            ))}
          </div>
          <Button isCancel onClick={closeModal} className="mt-4">
              Cancel
          </Button>
        </>
        ) : (
            <PleaseLogIn/>
        )}
    </ReactModal>
  );
};